import pagesNames from "../../constants/pages-names";

const homePageDataAr = {
    sectionOne : {
        title : "دمج  الممارسات البيئية والاجتماعية والحوكمة المؤسسية في صميم أعمالنا وأنشطتنا",
        subtitle : "ساهم بنك الأول، منذ يومه الأول، بدور حيوي في دفع عجلة النمو الاقتصادي والتقدم المجتمعي في المملكة. واليوم، نتحمل المسؤولية بأن نؤدي دورنا المحوري لتحقيق الفرق الحقيقي والدائم لبيئتنا ومجتمعاتنا وأصحاب المصلحة الذين تربطهم علاقة بنا.",
        button : {
            text : "استراتيجيتنا",
            path : pagesNames.starategy,
        }
    },
    chairmanSection : {
        description : "كان العام قيد المراجعة مبشرًا وواعدًا من نواحٍ عديدة، حيث دخل بنك الأول عامه الثاني من تنفيذ استراتيجيته المؤسسية لعام 2025، والتي تركز على دعم عملائنا واستراتيجياتهم للتحوّل الرقمي والتمويل المستدام. ويسعدني أن أرى ما حققناه من تقدم في ميدان الممارسات البيئية والاجتماعية والحوكمة المؤسسية، التي تعد جزءً لا يتجزأ من هوية الأول، بينما نتطلع إلى الانتقال نحو الاقتصاد منخفض الانبعاثات الكربونية.",
        info : {
            name : "لبنى سليمان العليان",
            position : "رئيس مجلس الإدارة",
        }
    },
    gallerySection : {
        rowOne : [
            {
                title : "أبرز النقاط 2022",
                subtitle : "كان 2022 عامًا إيجابيًا من حيث أدائنا المالي وما حققناه من تقدم في استراتيجية الممارسات البيئية والاجتماعية والحوكمة المؤسسية. ندرك أن تأثيرات تغير المناخ محسوسة بالفعل، ومن ثم ينبغي أن نسّرع جهودنا على صعيد الممارسات البيئية والاجتماعية والحوكمة المؤسسية على المدى القصير إلى المتوسط.",
                image : {
                    src : "2022-heighlight-card.jpg",
                    alt : "2022 Highlights background",
                },
                button : {
                    text : "أقرأ المزيد",
                    path: pagesNames.highlight,
                },
            },
            {
                title : "تقريرنا الأول للممارسات البيئية والاجتماعية والحوكمة المؤسسية",
                subtitle : "يتضمن هذا التقرير بيانات وافية عن المعايير التي استرشدنا بها فيما يخص الحوكمة البيئية والاجتماعية والمؤسسية لوضع الاستراتيجية المؤسسية وأطر الحوكمة وأخلاقيات العمل",
                image : {
                    src : "our-lnaugural-esg-report-card.jpg",
                    alt : "Our Inaugural ESG Report background",
                },
                button : {
                    text : "أقرأ المزيد",
                    path: pagesNames.reports,
                },
            },
        ],
        rowTwo : [
            {
                title : "التحول لعمليات خالية من الانبعاثات",
                subtitle : "يُدرك بنك الأول أن معالجة قضايا تغير المناخ تمثل تحدياً عاجلاً ومعقداً، يتطلب تحولاً جوهرياً في الاقتصاد العالمي.",
                image : {
                    src : "transition-to-net-zero-card.jpg",
                    alt : "mills over the sea background",
                },
                button : {
                    text : "أقرأ المزيد",
                    path: pagesNames.transition,
                },
            },
            {
                title : "الحوكمة",
                subtitle : "يعمل الأول وفق أساس متين من الحوكمة التي تخلق القيمة، حيث نعتقد أن اتباع نهج قوي للحوكمة هو من العوامل المهمة لتحقيق الاستدامة لدينا.",
                image : null,
                button : {
                    text : "أقرأ المزيد",
                    path: pagesNames.commitments,
                },
            },
        ],
    },
    imageAndBoxSection : {
        image : {
            src : "",
            alt : "رجل يجلس على كرسي وينظر إلى ساعته",
        },
        title : "عملية تحديد الأهمية النسبية لبنك الأول",
        subtitle : "بهدف تحديد القضايا الجوهرية بالنسبة للبنك، اتبعنا عملية تحليل قوية ومشاركة أصحاب المصلحة بناء على العناصر الكمية والنوعية.",
        button : {
            text : "القضايا الجوهرية",
            path : pagesNames.materials,
        }
    },
    gridSection : {
        flexOne : [
            {
                title : "الطاقة والانبعاثات",
                path : pagesNames.emissions,
                image : {
                    name : "solar-panels.jpg",
                    alt : "ناطحات سحاب أمام البحر",
                },
                type : "image",
                
            },
            {
                title : "منتجات وخدمات مستدامة",
                path : pagesNames.sustainableFinancing,
                image : {
                    name : "clouds.mp4",
                    alt : "Sky and clounds",
                },
                type : "video",
            }
        ],
        boxOne : {
            description : "وضمن مساعيه لتنفيذ الأهداف المحددة ضمن السعودية 2030، يساهم بنك الأول أيضا في تحقيق العديد من أهداف التنمية المستدامة للأمم المتحدة.",
            button : {
                text : "رؤية السعودية 2030",
                discription : "View or vidion in 2030 and UNSDGs",
                path : pagesNames.vision,
            }
        },
        flexTwo : [
            {
                title : "مشروع المستقبل: المكتب الذكي الجديد لبنك الأول",
                subtitle : "وتضمنت جهودنا الرامية إلى توسيع نطاق الاستدامة البيئية في عملياتنا تحديث مكاتبنا لتعزيز التحول نحو ممارسات أكثر استدامة.",
                button : {
                    text : "أقرأ المزيد",
                    path : pagesNames.environment,
                },
                image : {
                    name : "project-future-card.jpg",
                    alt : "Project future background",
                },
            },
            {
                title : "الأثر الاجتماعي",
                subtitle : "الاضطلاع بدور رائد في مسيرة بناء مجتمع يتسم بالشمول والتنوع بما يُحقق تأثيراً إيجابياً لدى أصحاب المصلحة",
                button : {
                    text : "أقرأ المزيد",
                    path : pagesNames.social,
                },
                image : {
                    name : "social-imact.jpg",
                    alt : "Social Impact background",
                },
            },
            {
                title : "الهدف العام",
                subtitle : "الالتزام بمستوى عالٍ من الحوكمة وتعزيز النزاهة والمسؤولية في جميع عمليات صنع القرار.",
                button : {
                    text : "اقرأ المزيد",
                    path : pagesNames.governance,
                },
                image : {
                    name : "overarching-card.jpg",
                    alt : "A picture of a cat sitting on a windowsill",
                },
            },
        ]
    }
}

export default homePageDataAr;